import { useEffect, useState } from 'react';
import { getMe, type AccountInfo } from '../../lib/conversationsApi';
import { IconEdit } from './icons';
import './accountFooter.css';

interface AccountFooterProps {
  onOpenSettings?: () => void;
  onNewChat?: () => void;
  newChatLabel?: string;
}

// WebApp.dc.html's sidebar footer ("2,140 credits left · Top up",
// "Sara M. · Pro plan") -- GET /api/me already returns exactly this
// (subscription.used/quota/planName, user.name), it just had no display
// surface. "Top up" opens Settings -- there is no separate checkout/upgrade
// screen yet, so that's the only real destination for it today.
export function AccountFooter({ onOpenSettings, onNewChat, newChatLabel = 'New chat' }: AccountFooterProps) {
  const [account, setAccount] = useState<AccountInfo | null>(null);

  useEffect(() => {
    getMe().then(setAccount).catch(() => {});
  }, []);

  if (!account && !onNewChat) return null;
  const sub = account?.subscription;
  const creditsLeft = sub ? Math.max(0, sub.quota - sub.used) : null;

  return (
    <div className="ozira-account-footer">
      {creditsLeft !== null ? (
        <div className="ozira-account-footer__credits">
          <span>{creditsLeft.toLocaleString()} credits left</span>
          <button type="button" className="ozira-account-footer__topup" onClick={onOpenSettings}>
            Top up
          </button>
        </div>
      ) : null}
      <div className="ozira-account-footer__actions">
      {account ? <button type="button" className="ozira-account-footer__profile" onClick={onOpenSettings}>
        <span className="ozira-account-footer__avatar" aria-hidden="true">
          {(account.name || '?').trim().charAt(0).toUpperCase()}
        </span>
        <span className="ozira-account-footer__identity">
          <span className="ozira-account-footer__name" title={account.name || 'Account'}>{account.name || 'Account'}</span>
          {sub ? <span className="ozira-account-footer__plan">{sub.planName}</span> : null}
        </span>
      </button> : null}
      {onNewChat ? <button type="button" className="ozira-account-footer__new-chat" aria-label={newChatLabel} title={newChatLabel} onClick={onNewChat}>
        <IconEdit width={18} height={18} />
      </button> : null}
      </div>
    </div>
  );
}
